import * as log from 'loglevel';
import * as _ from 'lodash';
import * as ko from 'knockout';
import {ComputedOptions} from "~knockout/index";
import {getSecondaryScreenVisibilityOptions} from "../../ScreenVisibility";
import {Screen} from "../../Screen";
import {Observable} from "~knockout/index";
import {ObservableArray} from "~knockout/index";
import {playUiVoiceover} from '../../../audio/voiceovers/VoiceOverManager';
import {Computed} from '~knockout/index';
import {getDifficultyLevel} from '../../main-menu/difficulty-select/DifficultySelectScreen';
import {showSecondaryScreen} from '../../ScreenManager';
import {sortingGameData} from '../../../data/SortingGameData';
import {continueGameAfterQuestion} from '../questions/QuestionOverlayComponent';
import {getGameManager} from '../../../game/GameManager';
import {gameConfig} from '../../../game/config/GameConfig';
import {playSound} from '../../../game/audio/AudioManager';
import {transitionOut} from '../../transition-overlay/TransitionOverlay';


interface ISortingBin
{
    id: string;
}

interface ISortableItem
{
    id?: string;
    type?: string;
    isTop: Observable<boolean>;
}

var template = require('./SortingGameOverlayComponent.html');


class GameplaySortingGameOverlayComponent extends Screen
{
    hasPlayed: boolean;

    state: Observable<string>;
    items: ObservableArray<any>;
    itemID: Computed<string>;
    bins: ISortingBin[];
    selectedBin: Observable<string>;
    selectedBinElement: HTMLElement;
    busy: boolean;

    totalItems: number;
    firstAttempt: boolean;
    totalCorrect: number;

    timeRemaining: Observable<number>;
    timerInterval: number;

    origin: { x: number, y: number };

    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getSecondaryScreenVisibilityOptions('gameplay', 'sorting-game');
    }


    /**
     * create knockout bindings
     */
    createBindings()
    {
        super.createBindings();

        this.totalItems = 40;

        this.state = ko.observable();
        this.items = ko.observableArray();
        //this.itemID = ko.computed(getCurrentItemOptions());
        this.bins =
            [
                { id: 'plastic' },
                { id: 'paper' },
                { id: 'glass' },
                { id: 'metal' },
                { id: 'non-recyclable' }
                ];
        this.selectedBin = ko.observable();
        this.timeRemaining = ko.observable();
    }


    /**
     * when we show the game screen, start the game
     */
    onShow()
    {
        //  hide zingy

        TweenMax.set('.pp-sorting-game__title', { opacity: 1 });
        TweenMax.set('#sorting-game__items', { opacity: 1 });
        TweenMax.set('#zingy-sorting-game', { bottom: '-130%', right: '-150px' });
        TweenMax.set('.pp-sorting-game__result', {opacity: 0 });

        //  set the overlay state

        this.items(this.getRandomItems());

        //  reset properties

        this.totalCorrect = 0;
        this.firstAttempt = true;
        this.timeRemaining(25);

        this.timerInterval = setInterval(this.countDownTimer, 1000);

        //  make the last item in the list current

        transitionOut();

        //_.last(this.items()).isTop(true);

        setTimeout(() => this.promoteNextItem(), 1000);


        if (this.hasPlayed) return;

        this.hasPlayed = true;



        //playUiVoiceover('sorting-game--intro-0');
        //
        //setTimeout(() => playUiVoiceover('sorting-game--intro-1'), 3000);
        setTimeout(() => playUiVoiceover('sorting-game--intro-2'));

    }


    /**
     * count the timer down towards zero
     */
    countDownTimer = () =>
    {
        this.timeRemaining(Math.max(this.timeRemaining() - 1, 0));

        if (this.timeRemaining() > 0) return;

        //  when the timer reaches zero

        this.onGameEnd();
    };


    /**
     * create a list of random items to sort
     */
    getRandomItems() : ISortableItem[]
    {
        let oldItemIndex: number,
            itemIndex: number,
            itemIndexes: number[];

        itemIndexes = <number[]>_.times(this.totalItems, () =>
        {
            //  get a new item index

            itemIndex = _.random(0, 4);

            if (itemIndex == oldItemIndex) itemIndex ++;

            if (itemIndex == 5) itemIndex = 0;

            oldItemIndex = itemIndex;

            return itemIndex;
        });

        return _.map(itemIndexes, (index: number) =>
        {
            let itemObj: any;

            itemObj = _.clone(sortingGameData[index]);

            itemObj.isTop = ko.observable(false);
            itemObj.rotation = ko.observable('rotate(' + _.random(-10, 10) + 'deg) scale(0.66)');

            return itemObj;
        });
    }


    /**
     * when the stack of items is tapped, read out the top item
     */
    clickCurrentItem = () =>
    {
        log.debug('reading top item', _.last(this.items()));
    };


    /**
     * start dragging an item
     */
    startDrag = ($data: any, event: MouseEvent) =>
    {
        //  save the origin point of the event

        this.origin = { x: (event.pageX || (<any>event).changedTouches[0].pageX), y: (event.pageY || (<any>event).changedTouches[0].pageY)};

        //  add drag listeners to the document

        document.addEventListener('mousemove', this.onMove);
        document.addEventListener('touchmove', this.onMove);
        document.addEventListener('mouseup', this.stopDrag);
        document.addEventListener('touchend', this.stopDrag);
    };


    /**
     * when the user drags an item, check its position
     * @param event
     */
    onMove = (event: MouseEvent) =>
    {
        //  make the element follow the cursor

        TweenMax.set(this.currentItemElement, { x: (event.pageX || (<any>event).changedTouches[0].pageX) - this.origin.x, y: (event.pageY || (<any>event).changedTouches[0].pageY)- this.origin.y });

        //  test drag position and open bins if needed

        if (event.pageY < window.innerHeight * 0.5) return;

        var x: number,
            bindex: number;

        //  clamp the x value

        x = Math.min(Math.max(0, (event.pageX || (<any>event).changedTouches[0].pageX)), window.innerWidth);

        //  get the index of the bin we're dragging over

        bindex = Math.floor(x / (window.innerWidth / 5));

        //  and open the bin

        if (this.bins[bindex]) this.selectedBin(this.bins[bindex].id);
    };


    /**
     * release the object, either dropping it into a bin or moving it back to its starting position
     */
    stopDrag = (event: MouseEvent) =>
    {
        //  remove drag listeners

        document.removeEventListener('mousemove', this.onMove);
        document.removeEventListener('touchmove', this.onMove);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('touchend', this.stopDrag);

        this.busy = true;

        //  have we selected a bin?

        var x: number,
            bindex: number;

        //  clamp the x value

        x = Math.min(Math.max(0, (event.pageX || (<any>event).changedTouches[0].pageX)), window.innerWidth);

        //  get the index of the bin we're dragging over

        bindex = Math.floor(x / (window.innerWidth / 5));

        this.selectedBin() === _.last(this.items()).id ? this.throwIntoBin(bindex) : this.recentreItem();
    };


    /**
     * throw an item into a bin
     * @param bindex
     */
    throwIntoBin(bindex: number)
    {
        let itemElement: HTMLElement,
            itemBounds: ClientRect,
            binElement: HTMLElement,
            binBounds: ClientRect,
            timeline: TimelineMax;

        //  play Vo

        playUiVoiceover('sorting-game--' + this.selectedBin());


        //  flag that we've got an item correct

        this.totalCorrect ++;

        //  get the bounding rect of the dragged item

        itemElement = this.currentItemElement;
        itemBounds = itemElement.getBoundingClientRect();

        //  get the selected bin element

        binElement = <HTMLElement>document.getElementById('sorting-game__bins')
            .getElementsByClassName('pp-sorting-game__sorting-bin').item(bindex)
            .getElementsByTagName('IMG').item(1);

        //  and get its bounds

        binBounds = binElement.getBoundingClientRect();

        timeline = new TimelineMax();

        timeline.to(itemElement, 0.7, { x: (binBounds.left + binBounds.width * 0.5) - window.innerWidth * 0.5, transformOrigin:"50% 50%" }, 0);
        timeline.to(itemElement, 0.7, { rotation: _.random(-560, 560), scale: 0.25, ease: Quad.easeInOut }, 0);
        timeline.to(itemElement, 0.35, { y: binBounds.top - itemBounds.top + itemBounds.height * 0.5 - binBounds.height * 0.1, ease: Sine.easeOut }, 0);
        timeline.to(itemElement, 0.35, { y: binBounds.top - itemBounds.top + itemBounds.height + binBounds.height * 0.1, ease: Sine.easeIn }, 0.35);
        timeline.to(itemElement, 0.1, { opacity: 0, ease: Quad.easeIn }, 0.6);
        timeline.add(() =>
        {

            //  remove the last item from the array

            this.items.pop();

            //  promote the next item

            this.promoteNextItem();
            this.selectedBin(null);
        }, '+=0');

    }


    /**
     * throw an item into a bin
     * @param bindex
     */
    throwIntoBinFromTop(bindex: number)
    {
        let itemElement: HTMLElement,
            itemBounds: ClientRect,
            binElement: HTMLElement,
            binBounds: ClientRect,
            timeline: TimelineMax;

        //  flag that we've got an item correct

        this.totalCorrect ++;

        //  get the bounding rect of the dragged item

        itemElement = this.currentItemElement;
        itemBounds = itemElement.getBoundingClientRect();

        //  get the selected bin element

        binElement = <HTMLElement>document.getElementById('sorting-game__bins')
            .getElementsByClassName('pp-sorting-game__sorting-bin').item(bindex)
            .getElementsByTagName('IMG').item(1);

        //  and get its bounds

        binBounds = binElement.getBoundingClientRect();

        timeline = new TimelineMax();

        timeline.to(itemElement, 0.7,
            {
                rotation: _.random(-360, 360),
                scale: 0.25,
                x: (binBounds.left + binBounds.width * 0.5) - window.innerWidth * 0.5,
                y: (binBounds.top - itemBounds.top) + binBounds.height * 0.1 - itemBounds.height * 0.5,
                //transformOrigin: "50% 50%",
                ease: Sine.easeInOut
            }, 0);
        timeline.to(itemElement, 0.1, { opacity: 0, ease: Quad.easeIn }, 0.6);
        timeline.add(() =>
        {

            //  remove the last item from the array

            this.items.pop();

            this.busy = false;

            //  promote the next item

            this.promoteNextItem();
            this.selectedBin(null);
        }, '+=0');
    }


    /**
     * re-centre the item
     */
    recentreItem()
    {
        let item: HTMLElement,
            timeline: TimelineMax;

        //  close the bin

        this.selectedBin(null);

        //  if the user got this right first time, record the point

        this.firstAttempt = false;

        //  get the top item in the list

        item = this.currentItemElement;

        timeline = new TimelineMax();

        timeline.to(item, 0.75, { x: 0, y: 0, ease: Expo.easeOut, easeParams: [0.9] }, 0);
        timeline.add(() =>
        {
            this.busy = false;
        }, '+=1');
    }



    /**
     * choose a bin to drop an item into
     */
    selectBin = (binID: string, $data: any, event: MouseEvent) =>
    {
        //console.log('click bin', this.busy, binID, $data, event)

        if (this.busy) return;

        //  play bin VO

        playUiVoiceover('sorting-game--' + binID);


        //  make the element follow the cursor

        //TweenMax.set(this.currentItemElement, { x: event.pageX - this.origin.x, y: event.pageY - this.origin.y });

        //  test drag position and open bins if needed

        if ((event.pageY || (<any>event).changedTouches[0].pageY) < window.innerHeight * 0.5) return;

        var x: number,
            bindex: number;

        //  clamp the x value

        x = Math.min(Math.max(0, (event.pageX || (<any>event).changedTouches[0].pageX)), window.innerWidth);

        //  get the index of the bin we're dragging over

        bindex = Math.floor(x / (window.innerWidth / 5));

        //console.log(x, window.innerWidth, bindex)
        //console.log(this.bins)

        //  and open the bin

        if (this.bins[bindex]) this.selectedBin(this.bins[bindex].id);

        //  throw the item into the bin

        this.busy = true;

        this.selectedBin() === _.last(this.items()).id ? this.throwIntoBinFromTop(bindex) : this.playIncorrectAnimation();
    };


    /**
     * move the top item in the list to the bin
     */
    playCorrectAnimation()
    {
        //  set busy state

        this.busy = true;

        //  move the item over to the bin

        let item: HTMLElement,
            itemBounds: ClientRect,
            binBounds: ClientRect,
            timeline: TimelineMax;

        //  if the user got this right first time, record the point

        this.totalCorrect ++;

        //  get the top item in the list

        item = this.currentItemElement;

        //  get item offset and bin offset

        itemBounds = item.getBoundingClientRect();
        binBounds = this.selectedBinElement.getBoundingClientRect();

        timeline = new TimelineMax();

        timeline.to(item, 0.8, { scale: 1.2, rotation: _.random(-20, 20), transformOrigin:"50% 50%", ease: Back.easeInOut }, 0);
        timeline.to(item, 0.8,
            {
                x: binBounds.left - itemBounds.left + (binBounds.width * 0.5) - (itemBounds.width * 0.5),
                //y: binBounds.top - itemBounds.top - itemBounds.height,
                ease: Expo.easeInOut
            }, '+=0');
        timeline.to(item, 0.4,
            {
                y: binBounds.top - itemBounds.top - itemBounds.height,
                ease: Expo.easeInOut
            }, 0);
        timeline.to(item, 0.4,
            {
                y: binBounds.top - itemBounds.top - itemBounds.height * 0.5,
                ease: Quad.easeIn
            }, 0.4);
        timeline.to(item, 0.1,
            {
                opacity: 0,
                ease: Expo.easeOut
            }, 0.7);
        timeline.add(() =>
        {
            //  remove the last item from the array

            this.items.pop();

            //  promote the next item

            this.promoteNextItem();
            this.selectedBin(null);
        }, 0.5);
    }


    /**
     * make the next item in the list current
     */
    promoteNextItem()
    {
        //  reset first attempt count for the new item

        this.firstAttempt = true;

        //  check the list of items; if we have any left then make the new top item current

        if (this.items().length)
        {
            //  make the top item the new current item

            _.last(this.items()).isTop(true);

            let item: HTMLElement;

            //  get the top item in the list

            item = this.currentItemElement;

            TweenMax.to(item, 0.8, { scale: 1, rotation: _.random(-10, 10), ease: Back.easeOut });

            //  reset busy state

            this.busy = false;

            return;
        }

        this.onGameEnd();
    }


    /**
     * when the game ends, award bonus time based on the number of right-first-time attempts
     */
    onGameEnd()
    {
        let bonusTime: number;

        //  clear the countdown timer

        clearInterval(this.timerInterval);

        //  work out how much bonus time to award the player based on the number of first-time correct answers

        bonusTime = Math.ceil(gameConfig.game.sortingBonusTime * this.totalCorrect);

        //  if the answer is correct, award the user some bonus time

        getGameManager().incrementTimeRemaining(bonusTime);

        //  display power-up effect to the user

        var resultText: string,
            bonusScoreText: string;

        if ( ! bonusTime)
        {
            resultText = "You didn't sort any items.";
            bonusScoreText = 'No bonus this time :(';
        }
        else if (this.totalCorrect === 1)
        {
            resultText = "You sorted 1 item.";
            bonusScoreText = '+' + bonusTime + ' seconds';
        }
        else
        {
            resultText = "You sorted " + this.totalCorrect + ' items.';
            bonusScoreText = '+' + bonusTime + ' seconds';
        }

        document.getElementsByClassName('pp-sorting-game__result__title').item(0).textContent = resultText;
        document.getElementsByClassName('pp-sorting-game__result__time-bonus').item(0).textContent = bonusScoreText;

        // bonusTime === 0 ? getGameManager().visibleBonus('No bonus time') : getGameManager().visibleBonus('+' + bonusTime + ' seconds');

        //  play sound

        playSound('correct-answer');

        //  show zingy! YAY!

        var timeline: TimelineMax;

        timeline = new TimelineMax();

        TweenMax.set('#zingy-sorting-game', { display: 'none' });
        timeline.to('.pp-sorting-game__title', 0.5, { opacity: 0, ease: Expo.easeOut }, 0);
        timeline.to('#sorting-game__items', 0.5, { opacity: 0, ease: Expo.easeOut }, 0.5);
        timeline.to('.pp-sorting-game__result', 0.5, { opacity: 1, ease: Expo.easeOut }, 1);
        timeline.fromTo('#zingy-sorting-game', 1, { bottom: '-100%', right: '-150px' }, { display: 'block', bottom: '-50px', right: '-80px', ease: Expo.easeOut }, 1.5);

        //  if we've completed all items in the list, continue the game

        setTimeout(() => continueGameAfterQuestion(), 4000);
    }


    /**
     * the user has guess
     */
    playIncorrectAnimation()
    {
        let timeline: TimelineMax,
            item: HTMLElement;

        //  flag that we've had an incorrect attempt on this item

        this.firstAttempt = false;

        //  get the top element

        item = this.currentItemElement;

        //  create a timeline and do a incorrect wiggle animation, setting the busy flag back to false again when we're done

        timeline = new TimelineMax();

        timeline.to(item, 0.15, { x: 50, ease: Expo.easeIn }, 0);
        timeline.to(item, 1, { x: 0, ease: Elastic.easeOut, easeParams: [1.5, 0.15] }, 0.15);
        timeline.add(() =>
        {
            this.busy = false;
            this.selectedBin(null);
        }, 1);
    }


    /**
     * do a little rollover animation when we touch the sorting item
     */
    focusItem()
    {
        let item: HTMLElement;

        //  get the top element

        item = this.currentItemElement;

        TweenMax.to(item, 0.5, { scale: 1.05, ease: Back.easeOut });
    }


    /**
     * do-focus item when we roll off it
     */
    blurItem()
    {
        let item: HTMLElement;

        if (this.busy) return;

        //  get the top element

        item = this.currentItemElement;

        TweenMax.to(item, 0.5, { scale: 1, ease: Expo.easeOut });
    }


    /**
     * get the element associated with the current sorting item
     * @return {HTMLElement|null}
     */
    get currentItemElement() : HTMLElement
    {
        return document.getElementById('current-sorting-item');
    }


    /**
     * get the URL for a sorting-item image
     * @param id
     * @return {string}
     */
    getItemImageUrl(id: string) : string
    {
        return 'assets/images/sorting-game/' + id + '.png';
    }

    /**
     * get the URL for a sorting-item image
     * @param id
     * @return {string}
     */
    getBinImageUrl(id: string) : string
    {
        return 'assets/images/sorting-game/bin-' + id + '.png';
    }
}



/**
 * register this component with knockout
 */
export function registerSortingGameOverlayComponent()
{
    ko.components.register('pp-gameplay-sorting-game-overlay',
        {
            viewModel: () => { return new GameplaySortingGameOverlayComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/gameplay/sorting-game/SortingGameOverlayComponent.ts